import React, { useState } from "react";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Button, Drawer, Form, Select } from "@payping/web-components";
import { Close } from "@payping/icons";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import location from "@/assets/location.json";
import { DashboardRoutes } from "@/router/constant";
import { useIsLocalDisabled } from "@/mobile/Settings/Business/Edit/utils/useIsLocalDisabled";
import { BusinessInformation } from "@/pages/Settings/Business/type";
import { useHandleNavigationURL, useSaveToRedux } from "../utils";
import { useImmerAtom } from "jotai-immer";
import { settingsBusinessAtom } from "../../state";
import { selectAtom } from "jotai/utils";
import { useAtom } from "jotai";

const mobileFormEditAtom = selectAtom(settingsBusinessAtom, (val) => val.mobileFormEdit);

const { Option } = Select;
const MobileEditBusinessState: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);

  const { t } = useAppTranslation();
  const [form] = Form.useForm<BusinessInformation>();
  const isLocalDisabled = useIsLocalDisabled();
  const [mobileFormEditState] = useAtom(mobileFormEditAtom);

  const stateApi = useAppSelector((state) => state.user.localInfo?.state);
  const [, setSettingsBusinessState] = useImmerAtom(settingsBusinessAtom);

  // Custom Hooks
  const { saveToRedux } = useSaveToRedux();
  const { handleNavigationURL } = useHandleNavigationURL();

  return (
    <>
      <Drawer
        placement={"bottom"}
        open={isDrawerOpen}
        height={"100%"}
        title={`${t("edit")} / ${t("state")}`}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
      >
        <Form<BusinessInformation>
          onFinish={async ({ state }: BusinessInformation) => {
            const stateId = location.find((s) => s.stateName === state)?.stateId;
            setSettingsBusinessState((draft) => {
              draft.mobileFormEdit.stateId = stateId;
            });
            await saveToRedux({
              nextUrlForMobileRegisterURL: DashboardRoutes.register.mEditBusiness.city.url,
              fieldName: "state",
              fieldValue: state,
              setIsDrawerOpen,
            });
          }}
          form={form}
          initialValues={{ state: mobileFormEditState.state ?? stateApi }}
        >
          <Form.Item
            rules={[{ required: true, message: t("settings.business.selectStateBeforeCity") }]}
            label={t("state")}
            name="state"
          >
            <Select disabled={isLocalDisabled}>
              {location.map((states) => (
                <Option value={states.stateName} key={states.stateId}>
                  {states.stateName}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Drawer>
      <EditActionButtons onAccept={form.submit} />
    </>
  );
};

export default MobileEditBusinessState;
